import React from 'react';

// Utils
import { SCHEMA_TYPE_MULTI_ENUM, SCHEMA_TYPE_TEXT, SCHEMA_TYPE_YOUTUBE } from '../../util/types';
import {
  isFieldForCategory,
  pickCategoryFields,
  pickCustomFieldProps,
} from '../../util/fieldHelpers.js';

import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionRundownMaybe from './SectionRundownMaybe';
import SectionDiscountsMaybe from './SectionDiscountsMaybe';
import SectionMultiEnumMaybe from './SectionMultiEnumMaybe';
import SectionTextMaybe from './SectionTextMaybe';
import SectionYoutubeVideoMaybe from './SectionYoutubeVideoMaybe';

/**
 * Renders custom listing fields.
 * - SectionDetailsMaybe is used if schemaType is 'enum', 'long', or 'boolean'
 * - SectionMultiEnumMaybe is used if schemaType is 'multi-enum'
 * - SectionTextMaybe is used if schemaType is 'text'
 *
 * @param {*} props include publicData, metadata, listingFieldConfigs, categoryConfiguration
 * @returns React.Fragment containing aforementioned components
 */
const CustomListingFields = props => {
  const {
    publicData,
    metadata,
    listingFieldConfigs,
    categoryConfiguration,
    // The Rundown extras (threaded from both ListingPage variants).
    title,
    priceText,
    priceUnit,
    listingId,
    // "Discounts Available" body section (Listing Richness) — Haul Star only,
    // sits between The Rundown and Trailer Details. isHaulStar is computed by
    // the parent (isHaulStarPlan(subscriptionName)).
    isHaulStar,
  } = props;

  const { key: categoryPrefix, categories: listingCategoriesConfig } = categoryConfiguration;
  const categoriesObj = pickCategoryFields(publicData, categoryPrefix, 1, listingCategoriesConfig);
  const currentCategories = Object.values(categoriesObj);

  const isFieldForSelectedCategories = fieldConfig => {
    const isTargetCategory = isFieldForCategory(currentCategories, fieldConfig);
    return isTargetCategory;
  };
  const propsForCustomFields =
    pickCustomFieldProps(
      publicData,
      metadata,
      listingFieldConfigs,
      'listingType',
      isFieldForSelectedCategories
    ) || [];

  return (
    <>
      {/* "The Rundown" — unique, crawlable SEO paragraph (SSR). Sits ABOVE the
          Trailer Details spec grid; renders nothing without enough data. */}
      <SectionRundownMaybe
        publicData={publicData}
        title={title}
        priceText={priceText}
        priceUnit={priceUnit}
        listingId={listingId}
      />
      {/* "Discounts Available" (Haul Star) — between The Rundown and Trailer
          Details. Text list, no cap; render-if-present. */}
      <SectionDiscountsMaybe publicData={publicData} isHaulStar={isHaulStar} />
      <SectionDetailsMaybe {...props} isFieldForCategory={isFieldForSelectedCategories} />
      {/* {propsForCustomFields.map(customFieldProps => {
        const { schemaType, ...fieldProps } = customFieldProps;
        return schemaType === SCHEMA_TYPE_MULTI_ENUM ? (
          <SectionMultiEnumMaybe {...fieldProps} />
        ) : schemaType === SCHEMA_TYPE_TEXT ? (
          <SectionTextMaybe {...fieldProps} />
        ) : schemaType === SCHEMA_TYPE_YOUTUBE ? (
          <SectionYoutubeVideoMaybe {...fieldProps} />
        ) : null;
      })} */}
      {/* schemaType === SCHEMA_TYPE_TEXT ? (
          <SectionTextMaybe {...fieldProps} />
        )  */}
    </>
  );
};

export default CustomListingFields;
